const usersColumns = {
  username: {
    key: 'username',
    label: 'username',
    type: 'text',
    sortable: 'custom',
  },
  email: {
    key: 'email',
    label: 'email',
    type: 'text',
    sortable: 'custom',
  },
  laboratory: {
    key: 'laboratory',
    label: 'laboratories',
    type: 'enum',
    enum: 'laboratories',
    sortable: false,
  },
  role: {
    key: 'role',
    label: 'roles',
    type: 'text',
    sortable: false,
  },
  location: {
    key: 'location',
    label: 'location',
    type: 'text',
    sortable: false,
  },
  isEnabled: {
    label: 'isEnabled',
    type: 'boolean',
    minWidth: 40,
    sortable: false,
    align: 'center',
  },
  actions: {
    key: 'actions',
    label: 'actions',
    type: 'actions',
    sortable: false,
    fixed: true,
    buttons: [
      {
        name: 'editUser',
        icon: 'fas fa-pencil',
        permissions: ['usersManage'],
        showCondition: (row) => row.username,
      },
      {
        name: 'disableUser',
        icon: 'fas fa-user-alt-slash',
        permissions: ['usersManage'],
        showCondition: (row) => !!row.isEnabled && row.username,
      },
      {
        name: 'enableUser',
        icon: 'fas fa-user',
        permissions: ['usersManage'],
        showCondition: (row) => !row.isEnabled && row.username,
      },
      {
        name: 'unlockUser',
        icon: 'fas fa-user-unlock',
        permissions: ['usersManage'],
        showCondition: (row) => row.isLocked && row.username,
      },
    ],
  },
};

export default usersColumns;
